package com.essntl.features.itinerary.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module


@Module
@ComponentScan("com.essntl.features.itinerary.domain.use_case")
class ItineraryServiceUseCaseModule